import { render } from "./PlanItem.vue?vue&type=template&id=53027ce7&scoped=true"
import script from "./PlanItem.vue?vue&type=script&lang=js"
export * from "./PlanItem.vue?vue&type=script&lang=js"

import "./PlanItem.vue?vue&type=style&index=0&id=53027ce7&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53027ce7"]])

export default __exports__